import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, reactive, onUpdated,nextTick } from "vue";
import { useI18n } from "vue3-i18n";
import { store } from "@/store/store";
import ResponseData from "@/types/ResponseData";
import Alert from "@/components/scan/parts/Alert.vue";
import WarrantyClaimDataService from "@/services/WarrantyClaimDataService";
import * as bootstrap from 'bootstrap';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();


const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const downloadDisableFlag = ref(false);
const errorMessage = ref('');
const modalBody = reactive([]);
const errorMessageDisableFlag = ref(false);

const entryStationCode = ref("");
const receivingStationCode = ref("");
const distributorCode = ref("");
const lotCode = ref("");
const receivingStationCodeError = ref("");
const distributorCodeError = ref("");
const lotCodeError = ref("");
const dataCount = ref("");
const csvFileCMAP = ref<File | null>(null);
const txtFileCMRB = ref<File | null>(null);

onMounted(()=>{
    entryStationCode.value = store.getters.stationCode;
});

// csvフォーマットファイルをダウンロード処理
const getCsvFormatFile = () =>{
    // 二回目実行にアラートメッセージが表示修正
    alertMessage.value = "null";
    alertState.value = "neutral";
    downloadDisableFlag.value = true;

    // ダウンロードcsvファイルのタイトル
    let csv_data = "\"Issue Number\",\"VIN\",\"Registered date(DDMMYY)\",\"Repaired date(DDMMYY)\",\"ODOmeter\",\"Complaint code\"," +
                         "\"Defect code\",\"Claim category code(Regular='0'; Campaign='2'; Packing='3'; Parts='7'; Before-Sales='8')\"," +
                         "\"Operation number\",\"Actual labor time for \"\"Other\"\"operation number\",\"Sublet hour\",\"Trouble/Repair description\"," +
                         "\"Causal part number\",\"Part number\",\"Quantity\"" ;

    const blob = new Blob([csv_data],{ type : "text/csv"});
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "CMAP_Format.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}

// CMAPボタンのチェック処理
const btnUpload = async() => {
    // エラーメッセージの表示
    const modal_element = document.getElementById("showModal"); 
    const modal = bootstrap.Modal.getOrCreateInstance(modal_element);

    modalBody.splice(0);
    errorMessage.value = "";
    errorMessageDisableFlag.value = false;
    // 二回目実行にアラートメッセージが表示修正
    alertMessage.value = "null";
    alertState.value = "neutral";
    entryStationCode.value = "1000";

    // 入力テキストボックスと入力csvファイルチェック
    const input_check = inputCheck();

    // 入力テキストボックスのデータと入力csvファイルのフォーマットが正しい場合、
    if (input_check == true){
        // 入力csvファイルないデータをチェック
        const check_file_data = await checkUploadFileData();
        // 入力csvファイルないデータが正しい場合、
        if (check_file_data == "check_result_ok"){
            convertCMAPCsv();
            downloadDisableFlag.value = false;
        }
        // 入力csvファイルないデータにエラーがある場合、
        else {
            if  (check_file_data == "check_result_error"){
                addError(i18n.t("alt135").replace("{0}", dataCount.value +1));
            }
            else if (dataCount.value == 0){
                addError(i18n.t("alt136"));
            }
        } 
    }
    downloadDisableFlag.value = false;
    modalBody.push(errorMessage.value.replace(/\\n/g,'\n'));

    // エラーがある時、モデルボックスが表示
    if (errorMessage.value != ''){
        csvFileCMAP.value!.value = '';
        modal.show();
    }
}

// エラーを追加処理
const addError = (message:any) => {
    if (errorMessage.value != ''){
        errorMessage.value = errorMessage.value + "\n" + message;
    }
    else{
        errorMessage.value = message;
    }
}

// 入力テキストボックスのデータと入力csvファイルのフォーマットチェック処理
const inputCheck = () => {
    let inputCheck;
    inputCheck = true;
    receivingStationCodeError.value = '';
    distributorCodeError.value = '';
    lotCodeError.value = '';
    receivingStationCode.value = (receivingStationCode.value).toUpperCase();
    distributorCode.value = (distributorCode.value).toUpperCase();
    lotCode.value = (lotCode.value).toUpperCase();

    // Receiving Station codeテキストボックスのデータチェック
    if (receivingStationCode.value == ""){
        addError(i18n.t("alt118").replace("{0}", "Receiving Station Code"));
        receivingStationCodeError.value = i18n.t("alt118").replace("{0}", "Receiving Station Code");
        inputCheck = false;
    } 
    else{
        if(!(/^[A-Z0-9]+$/.test(receivingStationCode.value))) {
            addError(i18n.t("alt119").replace("{0}", "Receiving Station Code"));
            receivingStationCodeError.value = i18n.t("alt119").replace("{0}", "Receiving Station Code");
            inputCheck = false;
        } 
        if(receivingStationCode.value.length != 4) {
            addError(i18n.t("alt120").replace("{0}", "Receiving Station Code").replace("{1}", "4"));
            receivingStationCodeError.value = i18n.t("alt120").replace("{0}", "Receiving Station Code").replace("{1}", "4");
            inputCheck = false;
        }
    }
    
    // Distributor codeテキストボックスのデータチェック
    if (distributorCode.value == ""){
        addError(i18n.t("alt118").replace("{0}", "Distributor Code"));
        distributorCodeError.value = i18n.t("alt118").replace("{0}", "Distributor Code");
        inputCheck = false;
    }
    else{
        if(!(/^[A-Z0-9]+$/.test(distributorCode.value))) {
            addError(i18n.t("alt119").replace("{0}", "Distributor Code"));
            distributorCodeError.value = i18n.t("alt119").replace("{0}", "Distributor Code");
            inputCheck = false;
        } 
        if(distributorCode.value.length != 5) {
            addError(i18n.t("alt120").replace("{0}", "Distributor Code").replace("{1}", "5"));
            distributorCodeError.value = i18n.t("alt120").replace("{0}", "Distributor Code").replace("{1}", "5");
            inputCheck = false;
        }
    } 
    
    // Lot codeテキストボックスのデータチェック
    if (lotCode.value == ""){
        addError(i18n.t("alt118").replace("{0}", "Lot No."));
        lotCodeError.value = i18n.t("alt118").replace("{0}", "Lot No.");
        inputCheck = false;
    } 
    else{
        if(!(/^[A-Z0-9]+$/.test(lotCode.value))) {
            addError(i18n.t("alt119").replace("{0}", "Lot No."));
            lotCodeError.value = i18n.t("alt119").replace("{0}", "Lot No.");
            inputCheck = false;
        } 
        if(lotCode.value.length < 1 || lotCode.value.length > 4) {
            addError(i18n.t("alt123").replace("{0}", "Lot No.").replace("{1}", "4"));
            lotCodeError.value = i18n.t("alt123").replace("{0}", "Lot No.").replace("{1}", "4");
            inputCheck = false;
        }
    }
            
    // 選択ファイルチェック
    const file = csvFileCMAP.value.files?.[0];
    const fileExtension = file?.name.split(".").pop()?.toLowerCase();
    // 入力ファイルない場合
    if (! file) {
        addError(i18n.t("alt121").replace("{0}", "CMAP"));
        inputCheck = false;
    } 
    // ファイルのフォーマットがcsvない場合
    else if (fileExtension !== "csv") {
        addError(i18n.t("alt122").replace("{0}", "CMAP"));
        inputCheck = false;
    }
    return inputCheck;
}

// 入力csvファイルないのデータチェック処理
const checkUploadFileData = async () => { 
    let check_upload_file_data;
    let check_result;
    check_upload_file_data = true;
    dataCount.value = "";
    const file = csvFileCMAP.value.files[0];
    let previous_issue_number = '';
    if (!file){
        return false;
    }
    const text = await file.text();
    const lines = text.split(/\r?\n/);
    for (let i = 1; i < lines.length; i++){
        dataCount.value = i;
        const line = lines[i].trim();
        if (i === lines.length - 1 && line == ''){
            break;
        }

        const columns = line.split(",").map(value => value.trim().replace(/^"(.*)"$/, "$1"));
        if(columns.length < 13 || columns.length > 21){
            addError(i18n.t("alt122").replace("{0}", "CMAP"));
            return "check_result_data";
        }
            
        // ファイルから列のデータを取得
        const issue_no = columns[0]?.trim();
        const vin = columns[1]?.trim();
        const format_registered_date = columns[2]?.trim();
        const format_repaired_date = columns[3]?.trim();
        const mileage = columns[4]?.trim();
        const complaint_code = columns[5]?.trim();
        const defect_code = columns[6]?.trim();
        const claim_category_code = columns[7]?.trim();
        const operation_code = columns[8]?.trim();
        const actual_labour_time = columns[9]?.trim();
        const sublet_hour = columns[10]?.trim();
        const description = columns[11]?.trim();
        const causal_part = columns[12]?.trim();
        const part_num1 = columns[13]?.trim();
        const quantity1 = columns[14]?.trim();
        const part_num2 = columns[15]?.trim();
        const quantity2 = columns[16]?.trim();
        const part_num3 = columns[17]?.trim();
        const quantity3 = columns[18]?.trim();
        const part_num4 = columns[19]?.trim();
        const quantity4 = columns[20]?.trim();
        // 新レコードの品質と異なる
        if (previous_issue_number == '' || previous_issue_number != issue_no){
            // 文字数と形式のチェック
            const issue_no_check_result = issueNoCheck(issue_no);
            const vin_check_result = vinCheck(vin);
            const date_check_result = dateCheck(format_registered_date, format_repaired_date);
            const mileage_check_result = mileageCheck(mileage);
            const complaint_check_result = complaintCodeCheck(complaint_code, defect_code);
            const claim_check_result = claimCategoryCodeCheck(claim_category_code);
            const operation_code_check_result = operationCodeCheck(operation_code);
            const work_time_check_result = workTimeCheck(operation_code, actual_labour_time, sublet_hour);
            const description_check_result = descriptionCheck(description);
            const causal_part_num_check_result = causalPartNumCheck(causal_part, part_num1);
            
            if (!(issue_no_check_result && vin_check_result && date_check_result && mileage_check_result && complaint_check_result && claim_check_result && operation_code_check_result && work_time_check_result && description_check_result && causal_part_num_check_result)){
                check_upload_file_data = false;
            }
        }
        const part_num_check_result = partNumCheck(part_num1, quantity1, part_num2, quantity2, part_num3, quantity3, part_num4, quantity4);
        const quantity_check_result = quantityCheck(part_num1, quantity1, part_num2, quantity2, part_num3, quantity3, part_num4, quantity4);
        if (check_upload_file_data){
            if (part_num_check_result && quantity_check_result){
                check_result = "check_result_ok";
            }
            else{
                check_result = "check_result_error";
                break;
            }
        }
        else{
            check_result = "check_result_error";
            break;
        }
        previous_issue_number = issue_no;
    }
    return check_result;
}

const parseDate = (value:any) => {
    let day, month, year
    if (value.length == 5){
        day = Number(String(value).substring(0,1));
        month = Number(String(value).substring(1,3));
        year = Number(String(value).substring(3,5));
    }
    else{
        day = Number(String(value).substring(0,2));
        month = Number(String(value).substring(2,4));
        year = Number(String(value).substring(4,6));
    }

    return `${year}0${month}${day}`;
}

// issueNoのデータチェック
const issueNoCheck = (issue_no:any) => {
    let issueNoCheck = true;

    // issueNoのデータの文字数が1~8ない場合
    if (issue_no.length < 1  ||  issue_no.length> 8){
        addError(i18n.t("alt123").replace("{0}", "Issue No.").replace("{1}", "8"));
        issueNoCheck = false;
    }

    // issueNoのデータの文字が英数字ではない場合
    if(!/^[\x20-\x7E]*$/.test(issue_no))  {
        addError(i18n.t("alt124").replace("{0}", "Issue No."));  
        issueNoCheck = false;
    }
    return issueNoCheck;
}

// vinのデータチェック
const vinCheck = (vin:any) => {
    let vincheck = true;
    // vinのデータの文字数が12,13,14,17ではない場合
    if (![12,13,14,17].includes(vin.length)){
        addError(i18n.t("alt125"));
        vincheck = false;
    }

    // issueNoのデータの文字が大文字アルファベット。数字。ハイフンではない場合
    if(!/^[A-Z0-9-]*$/.test(vin)){
        addError(i18n.t("alt126").replace("{0}", "VIN"));
        vincheck = false;
    }

    return vincheck;
}

// 日付のデータチェック
const dateCheck = (format_registered_date:any, format_repaired_date:any) => {
    let datecheck = true;

    // registered_dateは"0"以外。かつ'ddmmyy'形式ではない場合
    if (!validDateCheck(format_registered_date)){
        addError(i18n.t("alt127").replace("{0}", "Registered Date"));
        datecheck = false;
    }

    // repaired_dateは"0"以外。かつ'ddmmyy'形式ではない場合
    if (!validDateCheck(format_repaired_date)){
        addError(i18n.t("alt127").replace("{0}", "Repaired Date"));
        datecheck = false;
    }

    // repaired_dateがregistered_dateより前の日付で登録されている場合
    if (datecheck == true && format_registered_date != "000000" && parseDate(format_repaired_date) < parseDate(format_registered_date)){
        addError(i18n.t("alt128"));
        datecheck = false;
    }
    return datecheck;
}

// mileageのデータチェック
const mileageCheck = (mileage:any) => {
    let mileageCheck = true;

    // mileageのデータの文字数が1~5ではない場合
    if (mileage.length < 1 || mileage.length> 5){
        addError(i18n.t("alt123").replace("{0}", "ODOmeter").replace("{1}", "5"));
        mileageCheck = false;
    }

    // issueNoのデータの文字が数字ではない場合
    if (mileage != "" && (!/^[0-9]+$/.test(mileage))){
        addError(i18n.t("alt129").replace("{0}", "ODOmeter"));
        mileageCheck = false;
    }

    return mileageCheck; 
}

// complaintCodeのデータチェック
const complaintCodeCheck = (complaint_code:any, defect_code:any) => {
    let complaintCodeCheck = true;

    // complaintCodeのデータの文字数が1~2ではない場合
    if (complaint_code.length < 1 ||  complaint_code.length > 2){
        addError(i18n.t("alt123").replace("{0}", "Complaint code").replace("{1}", "2"));
        complaintCodeCheck = false;
    }

    // defectCodeのデータの文字数が2ではない場合
    if (defect_code.length != 2){
        addError(i18n.t("alt130"));
        complaintCodeCheck = false;
    }

    // complaintCodeとdefectCodeのデータの文字が大文字アルファベット。数字ではない場合
    if (!/^[A-Z0-9]*$/.test(complaint_code) || !/^[A-Z0-9]*$/.test(defect_code) ){
        addError(i18n.t("alt131").replace("{0}", "[Complaint] and [Defect code]"));
        complaintCodeCheck = false;
    }

    return complaintCodeCheck; 
}

// claimCategoryのデータチェック
const claimCategoryCodeCheck = (claim_category_code:any) => {
    let claimCategoryCodeCheck = true;

    // claimCategoryのデータの文字数が1ではない場合
    if (claim_category_code.length != 1){
        addError(i18n.t("alt132"));
        claimCategoryCodeCheck = false;
    }

    // claimCategoryのデータの文字が数字ではない場合
    if (!/^[0-9]+$/.test(claim_category_code)){
        addError(i18n.t("alt129").replace("{0}", "Claim Category"));
        claimCategoryCodeCheck = false;
    }

    return claimCategoryCodeCheck; 
}

// operationCodeのデータチェック
const operationCodeCheck = (operation_code:any) => {
    let operationCodeCheck = true;

    // operationCodeのデータの文字数が1~11ではない場合
    if (operation_code.length < 1 ||  operation_code.length > 11){
        addError(i18n.t("alt123").replace("{0}", "Operation number").replace("{1}", "11"));
        operationCodeCheck = false;
    }

    // operationCodeのデータの文字が大文字アルファベット。数字ではない場合
    if (!/^[A-Z0-9]*$/.test(operation_code)){
        addError(i18n.t("alt131").replace("{0}", "[Operation number]"));
        operationCodeCheck = false;
    }

    return operationCodeCheck;
}

// workTimeのデータチェック
const workTimeCheck = (operation_code:any,actual_labour_time:any,sublet_hour:any) => {
    let check_result = true;
    if (actual_labour_time == "" && operation_code != ""){
        if (operation_code.substring(operation_code.length - 4) == "9999"){
            addError(i18n.t("alt123").replace("{0}", "Labor hour").replace("{1}", "3"));
            check_result = false;
        }
    }
    if (actual_labour_time != ""){
        actual_labour_time = String(Number(actual_labour_time) * 10);
    }
    else{
        actual_labour_time = '000';
    }
    
    if (sublet_hour != ""){
        sublet_hour = String(Number(sublet_hour) * 10);
    }
    else{
        sublet_hour = '000';
    }
    // actual_labourのデータの文字数が1~3ではない場合
    if (actual_labour_time.length < 1 ||  actual_labour_time.length > 3){
        addError(i18n.t("alt123").replace("{0}", "Labor hour").replace("{1}", "3"));
        check_result = false;
    }

    // actual_labourのデータの文字が数字ではない場合
    else if (!/^[0-9]+$/.test(actual_labour_time)){
        addError(i18n.t("alt129").replace("{0}", "Labor hour"));
        check_result = false;
    }

    // sublet_hourのデータの文字数が1~3ではない場合
    if (sublet_hour.length < 1 || sublet_hour.length > 3){
        addError(i18n.t("alt123").replace("{0}", "Sublet hour").replace("{1}", "3")); 
        check_result = false;
    }

    // sublet_hourのデータの文字が数字ではない場合
    else if (!/^[0-9]+$/.test(sublet_hour)){
        addError(i18n.t("alt129").replace("{0}", "Sublet hour")); 
        check_result = false;
    }

    return check_result;
}

// descriptionのデータチェック
const descriptionCheck= (description:any) => {
    let descriptionCheck = true;

    // descriptionのデータの文字数が78以上場合
    if (description.length > 79){
        addError(i18n.t("alt123").replace("{0}", "Description").replace("{1}", "79"));
        descriptionCheck = false;
    }

    // descriptionのデータの文字が英数字ではない場合
    if (description != "" && !/^[\x20-\x7E]*$/.test(description)){
        addError(i18n.t("alt124").replace("{0}", "Description"));
        descriptionCheck = false;
    }

    return descriptionCheck; 
}

// causalPartのデータチェック
const causalPartNumCheck= (causal_part:any, part_num1:any)=> {
    let causalPartNumCheck = true;

    // causal_partのデータの文字数が1~15ではない場合
    if (causal_part.length < 1 || causal_part.length > 15){
        addError(i18n.t("alt123").replace("{0}", "Causal part number").replace("{1}", "15"));
        causalPartNumCheck = false;
    }
    
    // causal_partのデータの文字が大文字アルファベット。数字。ハイフンではない場合
    if (!/^[A-Z0-9-]*$/.test(causal_part)){
        addError(i18n.t("alt126").replace("{0}", "Causal part number"));
        causalPartNumCheck = false;
    }

    // causal_partのデータがXではない。causal_partとpart_numが異なる場合
    if (causal_part != "X" && causal_part != part_num1) {
        addError(i18n.t("alt133").replace("{0}", "Part number").replace("{1}", "Causal part number"));
        causalPartNumCheck = false;
    } 
    return causalPartNumCheck;
}

// partNumのデータチェック
const partNumCheck = (part_num1:any, quantity1:any, part_num2:any, quantity2:any, part_num3:any, quantity3:any, part_num4:any, quantity4:any)=> {
    let part_num_check = true;
    const quantitys = [
        quantity1,
        quantity2,
        quantity3,
        quantity4
    ]
    const partNums = [
        part_num1,
        part_num2,
        part_num3,
        part_num4
    ]
    
    for (let i = 0; i < 4; i++){
        if (String(partNums[i] ?? '').trim() !== ''){
            
            // partNumのデータの文字数が11~15ではない場合
            if (String(partNums[i]).length < 11 || String(partNums[i]).length > 15){
                addError(i18n.t("alt134"));
                part_num_check = false;
            }

            // partNumのデータの文字が大文字アルファベット。数字。ハイフンではない場合
            if (!/^[A-Z0-9-]*$/.test(partNums[i])){
                addError(i18n.t("alt126").replace("{0}","Part number"));
                part_num_check = false;   
            }
        }
        else{
            // partNumとquantityが異なる場合
            if (partNums[i] != quantitys[i]){
                addError(i18n.t("alt133").replace("{0}", "Quantity").replace("{1}", "Part number"));
                part_num_check = false;   
            }
        }
    }
    return part_num_check;
} 

// quantityのデータチェック
const quantityCheck = (part_num1:any, quantity1:any, part_num2:any, quantity2:any, part_num3:any, quantity3:any, part_num4:any, quantity4:any)=> {
    let quantity_check = true;
    const partNums = [
        part_num1,
        part_num2,
        part_num3,
        part_num4
    ]
    const quantitys = [
        quantity1,
        quantity2,
        quantity3,
        quantity4
    ]
    for (let i = 0; i < 4; i++){
        if (String(quantitys[i] ?? '').trim() !== ''){
            // quantityのデータの文字数が1~2ではない場合
            if (String(quantitys[i]).length < 1 || String(quantitys[i]).length > 2){
                addError(i18n.t("alt123").replace("{0}", "Quantity" + (i + 1)).replace("{1}", "2" ));
                quantity_check = false;
            }

            // quantityのデータの文字が数字。ハイフンではない場合
            if (!/^[0-9]+$/.test(quantitys[i])){
                addError(i18n.t("alt129").replace("{0}", "Quantity" + (i + 1)));
                quantity_check = false;   
            }
        }
        else{
            // partNumsとquantityが異なる場合
            if (partNums[i] != quantitys[i]){
                addError(i18n.t("alt133").replace("{0}", "Quantity" + (i + 1)).replace("{1}", "Part number" + (i + 1) ));
                quantity_check = false;   
            }
        }
    }
    return quantity_check;
} 

const validDateCheck = (value:any) => {
    value = String(value|| "").trim();
    if(!/^\d{5,6}$/.test(value)){
        return false;
    }
    let day,month,year
    if (value.length == 5){
        day = Number(String(value).substring(0, 1));
        month = Number(String(value).substring(1, 3));
        year = Number(String(value).substring(3, 5));
    }
    else{
        day = Number(String(value).substring(0, 2));
        month = Number(String(value).substring(2, 4));
        year = Number(String(value).substring(4, 6));
    }
    if (month < 1 || month > 12){
        return false
    }
    const fullyear = 2000 + year;
    const date = new Date(fullyear,month,0).getDate();
    return day >= 1 && day <= date;
}

// txtFileCMRBボタンの処理
const btnConvert = () => {
    // エラーメッセージが表示
    const modal_element = document.getElementById("showModal");  
    const modal = bootstrap.Modal.getOrCreateInstance(modal_element);
    
    alertMessage.value = "null";
    alertState.value = "neutral";
    errorMessage.value = '';
    modalBody.splice(0);
    // 選択ファイルチェック
    const uploadFile = txtFileCMRB.value.files?.[0];
    const fileExtension = uploadFile?.name.split(".").pop()?.toLowerCase();
    
    // 入力ファイルがない場合
    if (! uploadFile) {
        addError(i18n.t("alt121").replace("{0}", "CMRB"));
    } 
      
    // ファイルのフォーマットがtxtない場合
    else if (fileExtension !== "txt") {
        addError(i18n.t("alt122").replace("{0}", "CMRB"));
    }

    // エラーがある場合エラーモデルボックスが表示
    if (errorMessage.value != ''){
        modalBody.push(errorMessage.value.replace(/\\n/g,'\n'));
        txtFileCMRB.value!.value = '';
        modal.show();
        return
    }

    // 入力txtファイルをバックアップから実行処理
    const txtFormDataCMRB = new FormData();
    txtFormDataCMRB.append("file",txtFileCMRB.value.files[0]);
    WarrantyClaimDataService.convertCsvFile(txtFormDataCMRB)
    .then((response: ResponseData) => {
        // 出力ファイルをCMRB_Download.csvとしてダウンロード
        const blob = new Blob([response.data],{ type: "text/csv"});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "CMRB_Download.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        txtFileCMRB.value!.value = '';
    });
}

// 入力csvファイルをバックアップから実行処理
const convertCMAPCsv = () => {
    const formData = new FormData();
    formData.append("file", csvFileCMAP.value.files[0]);
    formData.append("entryStationCode", entryStationCode.value);
    formData.append("receivingStationCode", receivingStationCode.value);
    formData.append("distributorCode", distributorCode.value);
    formData.append("lotCode", lotCode.value);
    formData.append("userId", store.getters.cognitoUserName);
    WarrantyClaimDataService.getUploadFileData(formData)
    .then((response) => {
        // 出力ファイルをCMAP_Download.txtとしてダウンロード
        const blob = new Blob([response.data], {type:"text/explain"});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "CMAP_Download.txt";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        alertMessage.value = i18n.t("suc050");
        alertState.value = "success";
        csvFileCMAP.value!.value = '';
    })
    .catch((e: Error) => {
        const message = e?.response?.data?.message || e.message;
        if (message == 'failed to send') {
        alertMessage.value = i18n.t("err123");
        alertState.value = "error";
        }
        else if (message == 'Error Occurs') {
            alertMessage.value = i18n.t("err124");
            alertState.value = "error";
        }
        csvFileCMAP.value!.value = '';
      });
}

const showErrorMessage = () => {
    const modal_element = document.getElementById("showModal");  
    const modal = bootstrap.Modal.getOrCreateInstance(modal_element);
    modal.show();
}

const __returned__ = { alertMessage, alertState, i18n, downloadDisableFlag, errorMessage, modalBody, errorMessageDisableFlag, entryStationCode, receivingStationCode, distributorCode, lotCode, receivingStationCodeError, distributorCodeError, lotCodeError, dataCount, csvFileCMAP, txtFileCMRB, getCsvFormatFile, btnUpload, addError, inputCheck, checkUploadFileData, parseDate, issueNoCheck, vinCheck, dateCheck, mileageCheck, complaintCodeCheck, claimCategoryCodeCheck, operationCodeCheck, workTimeCheck, descriptionCheck, causalPartNumCheck, partNumCheck, quantityCheck, validDateCheck, btnConvert, convertCMAPCsv, showErrorMessage, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})